import React, { useMemo } from 'react';
import CascadeFilter from '@home/components/CascadeFilter';
import { IMetricFilterOption } from '@/pages/benchmark/pages/genre/components/BenchmarkFilter/useData';
import { getLocale } from 'umi';
import './index.scss';
import classNames from 'classnames';

interface IMetricsFilterProps {
  value: any;
  options: IMetricFilterOption[];
  onChange: (value: any) => void;
}

const MetricsFilter = (props: IMetricsFilterProps) => {
  const { value, options, onChange } = props;
  const isEN = getLocale() === 'en-US';
  const newOptions = useMemo(() => {
    const categorys: any = {};
    options?.forEach((item) => {
      const {
        category,
        category_ch,
        category_en,
        metric,
        metric_en,
        metric_ch,
      } = item;

      const metricOpt = {
        text: metric_en,
        textCN: metric_ch,
        value: metric,
      };

      if (categorys[category]) {
        categorys[category].children.push(metricOpt);
      } else {
        categorys[category] = {
          text: category_en,
          textCN: category_ch,
          value: category,
          children: [metricOpt],
        };
      }
    });

    return Object.keys(categorys).map((key) => categorys[key]);
  }, [options]);

  return (
    <CascadeFilter
      value={value}
      showBubble={true}
      onChange={onChange}
      regionKey="genre"
      marketKey="metrics"
      options={newOptions}
      maxSelectedNum={10}
      minSelectedNum={3}
      radioOptions={[]}
      locale={getLocale()}
      boxClassName={classNames("dbd-cascade-filter-select-drop-down-box-hide-left-all",
        {'dbd-benchmark-metrics-selector-box': isEN}
      )}
    />
  );
};

export default MetricsFilter;
